import { render } from "./TaskSettingsDependencies.vue?vue&type=template&id=4335edf4"
import script from "./TaskSettingsDependencies.vue?vue&type=script&lang=js"
export * from "./TaskSettingsDependencies.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsDependencies.vue?vue&type=style&index=0&id=4335edf4&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__